module.exports = __webpack_public_path__ + "img/acr.0355719c.png";